import React from "react";
import Reveal from "./Reveal";

const LAYERS = [
  {
    n: "01",
    verb: "LEARN",
    body: "Train AI capability across 11 launch certifications, 3 tiers (Native → Builder → Leader), and 4 channels (Schools, Colleges, Corporates, Individuals). Built on The Practitioner Method™.",
    href: "#certifications",
  },
  {
    n: "02",
    verb: "BUILD",
    body: "Mentor builders through pod-based hackathons, capstone projects, and the AI Innovation Arena. Every certification ends in a shippable artifact, not a quiz score.",
    href: "#arena",
  },
  {
    n: "03",
    verb: "HIRE",
    body: "Connect AI talent to AI roles. AI-powered resume builder, smart job matching, interview prep for job seekers. AI talent matching and candidate search for employers.",
    href: "#beyond",
  },
  {
    n: "04",
    verb: "INVEST",
    body: "Back the founders who emerge. Capital, mentorship, GTM support, and network access — for the builders we've trained and the founders ready to scale.",
    href: "#beyond",
  },
];

export default function Ecosystem() {
  return (
    <section
      id="ecosystem"
      className="relative py-10 md:py-14 border-t hairline"
      data-testid="ecosystem-section"
    >
      {/* Diagonal pattern background */}
      <div className="absolute inset-0 pattern-diagonal opacity-60 pointer-events-none" />
      <div className="container-edge relative">
        <Reveal>
          <p className="section-number">01 — THE ECOSYSTEM</p>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="font-display text-[40px] sm:text-[52px] lg:text-[68px] leading-[0.95] tracking-tight" style={{ fontWeight: 500 }}>
                Most AI platforms stop at courses.
                <br />
                <em className="italic grad-brand-text" style={{ fontWeight: 500 }}>We don't.</em>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={120}>
              <p className="text-[17px] md:text-[18px] leading-relaxed" style={{ color: "var(--ink-secondary)" }}>
                Four layers, one compounding loop. Each layer feeds the next. Learners become builders.
                Builders become founders. Founders need talent. Talent comes back as learners. This is
                the AI For Everyone ecosystem.
              </p>
            </Reveal>
          </div>
        </div>

        {/* 4 cards */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--border-strong)] border hairline-strong">
          {LAYERS.map((l, i) => (
            <Reveal key={l.verb} delay={i * 80}>
              <a
                href={l.href}
                className="relative block h-full p-8 lg:p-10 bg-canvas hover:bg-white transition-colors group overflow-hidden"
                data-testid={`ecosystem-card-${l.verb.toLowerCase()}`}
              >
                <span
                  className="absolute top-0 left-0 right-0 h-[2px] transition-opacity opacity-0 group-hover:opacity-100"
                  style={{ background: "linear-gradient(90deg, #4F46E5 0%, #7C3AED 60%, #C9A961 100%)" }}
                />
                <span className="ghost-numeral" style={{ top: -40, right: -10 }}>
                  {l.n}
                </span>
                <div className="relative">
                  <p className="mono-label-gold">{l.n}</p>
                  <h3
                    className="mt-4 font-display text-[40px] tracking-tight grad-brand-text"
                    style={{ fontWeight: 600 }}
                  >
                    {l.verb}
                  </h3>
                  <p
                    className="mt-4 text-[14px] leading-relaxed min-h-[140px]"
                    style={{ color: "var(--ink-secondary)" }}
                  >
                    {l.body}
                  </p>
                  <span className="mt-6 inline-block text-[13px] link-underline text-ink">
                    Learn more →
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={400}>
          <p
            className="mt-10 font-display italic text-[22px] md:text-[26px] max-w-[760px]"
            style={{ color: "var(--ink-secondary)", fontWeight: 400 }}
          >
            "Train → Mentor → Hire → Invest. The full stack."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
